import { createSlice } from "@reduxjs/toolkit";
import { normalizeUserSession } from "../../../Utility/session";

const initialState = {
    isAuthenticated: false,
    IsLoginData:{},
    isUserInAllowedRegion:false,     // this is used for checking the vpn anmd ip with the help of ip api
    isVpn:false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // setIsAuthenticated: (state, action)=>{
    //     state.isAuthenticated = action.payload;
    //     state.IsLoginData ={}
    // },
    setLoginData: (state, action)=> {
      // console.log('action.payload',action.payload)
      // The refresh callers all do dispatch(setLoginData({ user: response?.data, ... }))
      // without checking the call succeeded, and getAllData returns the raw axios error
      // response (or undefined) on failure. Keeping the signed-in user rather than
      // storing that means one failed refresh no longer looks like a logout.
      const { user, isAuthenticated } = action.payload;
      if (isAuthenticated && !user?.idUser) {
        return;
      }
      state.IsLoginData = normalizeUserSession(user);
      state.isAuthenticated = isAuthenticated;
  },
   setLocationResponse:(state, action)=>{
    state.isUserInAllowedRegion = action.payload;
   },
   setVPNResponse:(state, action)=>{
    state.isVpn = action.payload;
   },
     
  },
});

// Action creators are generated for each case reducer function
export const { setLoginData,setLocationResponse,setVPNResponse } = authSlice.actions;

export default authSlice.reducer;
